// extracted by mini-css-extract-plugin
export var createdDate = "_lg-1";
export var divider = "_lg-2";
export var headerDivider = "_lg-3";
export var messagesCard = "_lg-0";
export var messagesContainer = "_lg-6";
export var messagesContainerWrapper = "_lg-4";
export var showLeftPanelButton = "_lg-8";
export var topButtons = "_lg-7";
export var withPadding = "_lg-5";